export const comments_3294068 = {"data":{"data":[],"links":{}}}